export default function FreezeSelectIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1801 9.02995L12.8501 9.64995L12.4601 9.44V6.56L12.8501 6.3L15.1801 6.92L15.7001 4.99L13.9301 4.52L14.3901 2.75L12.4601 2.23L11.8401 4.56L11.4501 4.82L9.0001 3.38V3.12L10.7101 1.41L9.2901 0L8.0001 1.29L6.7101 0L5.2901 1.41L7.0001 3.12V3.38L4.5001 4.82L4.1301 4.56L3.55011 2.23L1.63011 2.75L2.10011 4.52L0.330106 4.99L0.850106 6.92L3.18011 6.3L3.5501 6.56V9.45L3.28009 9.74716L0.950093 9.12716L0.430093 11.0572L2.20009 11.5272L1.73009 13.2872L3.66009 13.8072L4.28009 11.4772L4.5501 11.18L7.0001 12.62V12.88L5.2901 14.59L6.7101 16L8.0001 14.71L9.2901 16L10.7001 14.59L9.0001 12.88V12.62L11.5001 11.17L11.8901 11.38L12.5101 13.71L14.3901 13.2L13.9201 11.43L15.6901 10.96L15.1801 9.02995ZM5.5001 6.56L8.0001 5.11L10.5001 6.56V9.44L8.0001 10.89L5.5001 9.44V6.56Z"
        fill="#1079CA"
      />
    </svg>
  );
}
